import { SET_DIALOG_MESSAGE, CLEAR_DIALOG_MESSAGE } from 'shared-module/dialog/dialogActionsTypes'

const showError = (dialogMessage) => ({ type: SET_DIALOG_MESSAGE, dialogMessage })
const clear = () => ({ type: CLEAR_DIALOG_MESSAGE })

const dialogActions = { showError, clear }
export default dialogActions
